// extracted by mini-css-extract-plugin
export default {"container":"AboutMe_container__2BsCN","about_me":"AboutMe_about_me__xRBml","headshot_wrapper":"AboutMe_headshot_wrapper__oUG0L","about_me_text":"AboutMe_about_me_text__C1LlX"};